import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ZendeskHelp from '@/shared/components/ZendeskHelp';
import Checkbox from './Checkbox';

const CheckboxList = ({ items, onItemChanged, disabled, className, itemClassName }) => (
  <div className={classnames('checkbox-list', className)}>
    {items &&
      items.map(item => (
        <>
          {item.title ? <div className="bold">{item.title}</div> : null}
          <div key={item.id} className={classnames(itemClassName, item.individualClassName)}>
            <Checkbox
              value={item.selected}
              text={item.label}
              disabled={disabled}
              onClick={selected => onItemChanged(item, selected)}
            />
            {item.zendeskArticle ? <ZendeskHelp article={item.zendeskArticle} /> : null}
          </div>
        </>
      ))}
  </div>
);
CheckboxList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      selected: PropTypes.bool,
      label: PropTypes.string,
      individualItemClassName: PropTypes.string,
      zendeskArticle: PropTypes.string,
    }),
  ).isRequired,
  onItemChanged: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  itemClassName: PropTypes.string,
};
CheckboxList.defaultProps = {
  disabled: false,
  className: undefined,
  itemClassName: undefined,
};

export default CheckboxList;
